'use strict';
import {createActions} from 'client/framework';

const normalActions = [
  'ADVANCE_STEP',
  'SET_ACTIVE_STEP',
  'SET_INITIAL_STEP',
  'SET_FULL_STEP_LIST',
  'CLEAR_MOVEMENT_HANDLER',
  'RETREAT_STEP',
  'RESET_STEPS'
];

export default createActions(null, normalActions);
